import React, { useState, useEffect } from "react";
import {
  Container,
  IconButton,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import styles from "./NavBar.module.css";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

export default function NavBar() {
  const isMobile = useMediaQuery("(max-width:900px)");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Handle dropdown open
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle dropdown close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
      <header className={`${styles.sticky} ${scrolled ? styles.scrolled : ""}`}>
        <Container maxWidth="xl">
          <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="space-between"
              py={2}
          >
            {/* Logo */}
            <Link to="/">
              <img src={logo} alt="Logo" height={27} className="w-40" />
            </Link>

            {/* Navigation Links */}
            <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={4}
                alignItems={{ xs: "flex-start", md: "center" }}
                className={`${styles.navlinks} ${menuOpen ? styles.active : ""}`}
                pt={{ xs: 12, md: 1 }}
                pb={{ xs: 4, md: 1 }}
                px={{ xs: 4, md: 0 }}
            >
              <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
              <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
              <Link to="/specialist/2/dr-amit-vishen" onClick={() => setMenuOpen(false)}>Our Specialist</Link>

              {/* Dropdown for "Our Doctors" */}
              {/*<div
                  onMouseEnter={handleMenuOpen}
                  onMouseLeave={handleMenuClose}
                  style={{ position: "relative", cursor: "pointer" }}
              >
                <Link to="/" aria-haspopup="true" >
                  Our Specialists
                </Link>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    MenuListProps={{ onMouseLeave: handleMenuClose }}
                    sx={{ mt: 1 }}
                    disableScrollLock
                    disableAutoFocusItem
                >
                  <MenuItem component={Link} to="/specialist/2/dr-amit-vishen" onClick={() => {setMenuOpen(false);  handleMenuClose();}} >
                    Dr. Amit Vishen
                  </MenuItem>
                  <MenuItem component={Link} to="/specialist/1/dr-rucha-choudhari" onClick={() => {setMenuOpen(false);  handleMenuClose();}}>
                    Dr. Rucha Choudhari
                  </MenuItem>
                </Menu>
              </div>*/}

              <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
              <Link to="/blog" onClick={() => setMenuOpen(false)}>Blogs</Link>
              <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

              {/* Close Button for Mobile Menu */}
              {isMobile && menuOpen && (
                  <IconButton
                      aria-label="Close navigation menu"
                      onClick={() => setMenuOpen(false)}
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 32,
                        color: "#fff",
                      }}
                  >
                    <CloseIcon />
                  </IconButton>
              )}
            </Stack>

            {/* Mobile Menu Icon */}
            {isMobile && !menuOpen && (
                <IconButton
                    aria-label="Open navigation menu"
                    onClick={() => setMenuOpen(true)}
                >
                  <MenuIcon />
                </IconButton>
            )}
          </Stack>
        </Container>
      </header>
  );
}
